export default [
  {
    title: "Orders",
    icon: "ShoppingCartIcon",
    tagVariant: "success",
    children: [
      {
        title: "Orders",
        route: "orders-index",
        resource: "Orders",
        action: "GetOrder",
      },
      {
        title: "Pay by link",
        route: "request-paylink",
        resource: "Order",
        action: "PayByLink",
      },
    ],
  },
];
